import { Injectable } from '@angular/core';
import { TelemetryEndpointResolver } from '@cv-invision/cv.component-library.ux';
import { AppService } from '../service/app.service';
import { ConfigService } from '../service/config.service';
@Injectable()
export class IntelligenceEndpointResolver implements TelemetryEndpointResolver {
	private endpoint: string;

	constructor(private config: ConfigService, private appService: AppService) {
		this.config
			.getConfig()
			.toPromise()
			.then(data => {
				const {
					api: { telemetryService }
				} = data;
				this.endpoint = telemetryService;
			})
			.catch(e => console.warn(e));
	}

	/**
	 * Endpoint to send the telemetry events in intelligence
	 */
	getEndpoint(): string {
		const app = this.appService.getTelemetryAppName(location.pathname);
		return `${this.endpoint}/${app}/send`;
	}
}
